import { Component, ElementRef, HostListener, Output, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of } from 'rxjs';
import { ApiStatus, nodeType } from 'src/app/core/constants/constants';
import { ReformatObject, Submenu } from 'src/app/core/interface/flow-builder.interface';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { ConfirmAlertComponent } from 'src/app/shared/scad-widget/alerts/confirm-alert/confirm-alert.component';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-flow-landing-page',
  templateUrl: './flow-landing-page.component.html',
  styleUrls: ['./flow-landing-page.component.scss']
})
export class FlowLandingPageComponent {

  @ViewChild('drawflow') drawflowList!: ElementRef;

  public inputKey: any;
  public outputKey: any;
  public inputConnection: any = [];
  public outputConnection: any = [];
  public next: any;
  public previous: any;
  public formData: any = new FormData();
  subs:SubSink=new SubSink();
  zoomValue:number=0;
  @Output() testPreview: any = {};
  public apiLoadingRun: boolean = false;

  constructor(
    private _renderer2: Renderer2,
    public _flowBuilder: FlowBuilderService,
    private _router: Router,
    private _toast:ToastrService,
    private dialog: MatDialog,
  ) {
    this._flowBuilder.renderer2 = this._renderer2;
    // var range = document.getElementById("range");
    // var drawflow:any = document.getElementById("drawflow") as HTMLDivElement;

    // range?.addEventListener("change",()=> {
    //   drawflow.style['zoom'] = this.zoomValue; 
    // });
  }


  ngOnInit(): void {
  }

  sampleValueRestrit(){
    if(this._flowBuilder.sampleSize < 5){
      this._flowBuilder.sampleSize = 5
    }
  }


  ngAfterViewInit(): void {
    this._flowBuilder.drawFlowHtmlElement = <HTMLElement>document.getElementById('drawflow');
    this._flowBuilder.drawflowList = this.drawflowList;
    this._flowBuilder.initDrawFlow(this._flowBuilder?.drawFlowHtmlElement);

    // this.drawflowList.nativeElement.children[0].style.transform = this._flowBuilder.flowScale;
    
  }


  
  saveFlowbuilder() {
    let inputCount = 0, outputCount = 0;

    if (this._flowBuilder?.drawnNodeList?.length === 0) {
      // alert('Select atleast one node');
      this._toast.warning('Select atleast one node');
      return;
    } else {
      this._flowBuilder?.drawnNodeList?.forEach((item: Submenu) => {
        const ipVal = this._flowBuilder?.editor?.getNodeFromId(item.id)?.inputs;
        const opVal = this._flowBuilder?.editor?.getNodeFromId(item.id)?.outputs;
        const inputKey = Object.values(ipVal);
        inputCount += inputKey.length;
        const outputKey = Object.keys(opVal);
        outputCount += outputKey.length;
        inputKey.forEach((key?: any) => {
          this.inputKey = key;
          this.inputConnection = ipVal?.input_1?.connections;
        });
        outputKey.forEach((key?: any) => {
          this.outputKey = key;
          this.outputConnection = opVal[key]?.connections;
        });
      });
      if (this._flowBuilder?.createdConnectionList?.length != inputCount) {
        // alert('Please provide a connection');
        this._toast.warning('Please provide a connection');
        return;
      } else {
        this.dataToRunApi();
      }
    }
  }


  dataToRunApi(type?:string) {
    
    if(this._flowBuilder.isPublishToIfp || this._flowBuilder.drawnNodeList.length ===0 ){
      return;
    }
    this.formData?.delete(`source`);
    this.formData?.delete(`json_data`);
    this.formData?.delete(`workflow_identifier`);
    this.formData?.delete(`sample_size`);
    let delimiterSymbol: string;
    let obj: any = {};
    const gridData: any = {};
    let json = {};

    this._flowBuilder.drawnNodeList?.forEach((element: Submenu | any, index: number) => {
      const data = this._flowBuilder?.editor?.getNodeFromId(element?.id);
      

      if (Object.keys(data?.inputs).length === 0) {
        this.previous = [];
      } else {
        this.previous = Object.keys(data?.inputs)?.map((v: string) => data?.inputs[v]?.connections?.map((c: string | any) => c.node)
        );
      }

      if (data.class === 'Filter') {
        if (Object.keys(data?.outputs?.output_1)?.length === 0) {
          this.next = '';
        } else {
          this.next = Object.keys(data?.outputs)?.map((v: string) => data?.outputs[v]?.connections?.map((c: string | any) => c.node));
        }

        if (Object.keys(data?.outputs?.output_2)?.length === 0) {
          this.next = '';
        } else {
          this.next = Object.keys(data?.outputs)?.map((v: string) => data?.outputs[v]?.connections?.map((c: string | any) => c.node)
          );
        }
      }

      if (Object.keys(data?.outputs)?.length === 0) {
        this.next = '';
      } else {
        this.next = Object.keys(data?.outputs)?.map((v: string) => data?.outputs[v]?.connections?.map((c: string | any) => c.node)
        );
      }


      const key: any = [];
      const value: any = [];

      if (element?.name === 'Select') {
        if (!element['tempData']) {
          element['tempData'] = {};
        }

        element?.reFormat?.forEach((selData: ReformatObject) => {
          if (selData?.checked == true) {

            key?.push(selData?.originalName);
            value?.push(selData?.updatedName ? selData?.updatedName : selData?.originalName);

          }
        });
        element['tempData'] = {};
        for (let i = 0; i < key?.length && i < value?.length; i++) {
          gridData[key[i]] = value[i];
          element['tempData'][key[i]] = value[i];
        }

      }

      if (element?.name === 'Filter') {
        element?.filterFormat?.forEach((filtrData: { key: any; }) => {
          key?.push(filtrData?.key);
        });
        for (let i = 0; i < key?.length; i++) {
          gridData[key[i]] = key[i];
        }
      }



      const leftJoin: any = [];
      const leftValue: any = [];
      const rightJoin: any = [];
      const rightValue: any = [];
      const leftData:any = {};
      const rightData:any = {};

      if (element?.name === 'Join') {
        element?.LeftJoinFormat?.forEach((lft_data: { checked: boolean; key: any; letfUpdatedName: any; }) => {
          if (lft_data?.checked == true) {
            leftJoin?.push(lft_data?.key);
          }
          if (lft_data?.letfUpdatedName == null && lft_data?.checked == true) {
            leftValue?.push(lft_data?.key);
          } else if (lft_data?.letfUpdatedName != null && lft_data?.checked == true) {
            leftValue?.push(lft_data?.letfUpdatedName);
          }
        });
        for (let i = 0; i < leftJoin?.length && i < leftValue?.length; i++) {
          leftData[leftJoin[i]] = leftValue[i];
        }
        element?.RightJoinFormat?.forEach((right_data: { checked: boolean; key: any; rightUpdatedName: any; }) => {
          if (right_data?.checked == true) {
            rightJoin?.push(right_data?.key);
          }
          if (right_data?.rightUpdatedName == null && right_data.checked == true) {
            rightValue?.push(right_data?.key);
          } else if (right_data?.rightUpdatedName != null && right_data.checked == true) {
            rightValue?.push(right_data?.rightUpdatedName);
          }
        });
        for (let i = 0; i < rightJoin.length && i < rightValue.length; i++) {
          rightData[rightJoin[i]] = rightValue[i];
        }
      }

      const next: any = Object.values(this.next);
      const previous = Object.values(this.previous)?.map((v: number | any) => v.toString());

      if (element?.name === 'Source') {
        obj[element?.id] = {
          'fileKey': `Source${[index + 1]}`,
          'next': next?.toString(),
          'node': element?.name.toLowerCase(),
          'previous': previous,
          // 'type': element?.connection_type || null,
          'type': this._flowBuilder.fileType,
          'delimeter': delimiterSymbol,
        };
        
        // this.formData?.append(`Source${[index + 1]}`, element?.connection?.file);
        // if(this.formData.get('source')){
        //   let arr:any=[];
        //   arr.push(this.formData.get('source'));
        //   arr.push(element?.connection?.file);
        //   this.formData.delete('source');
        //   console.log(arr);
          
        //   this.formData?.append(`source`,arr)
        // }
        // else{
          this.formData?.append(`source`, element?.connection?.file);
        // }
      } else if (element?.name === 'Select') {

        obj[element?.id] = {
          'next': next?.toString(),
          'node': element?.name?.toLowerCase(),
          'previous': previous
        };
        obj[element?.id]['fields'] = element['tempData'];

      } else if (element?.name === 'Filter') {

        let nxtTrue = null;
        let nxtFalse = null;

        if (next[0] === null && next[1] !== null) {
          nxtTrue = null;
          nxtFalse = Object.values(next[1]);
        } else if (next[0] !== null && next[1] !== null) {
          nxtTrue = Object.values(next[0]);
          nxtFalse = Object.values(next[1]);
        }

        const ftrName = element?.selectedFilter;
        const ftrOperator = element?.operator;
        const ftrValue = element?.value;
        obj[element?.id] = {
          'basic_condition': {
            'filter_field': ftrName || null,
            'filter_operator': ftrOperator || null,
            'filter_value': ftrValue || null
          },
          'custom_conditions': null,
          'true': {
            'next': nxtTrue?.toString() || null
          },
          'false': {
            'next': nxtFalse?.toString() || null
          },
          'node': element?.name?.toLowerCase(),
          'previous': previous
        };
      }else if (element?.name === 'Join') {

        let joinFields = null;
        let inJoinFields = null;
        let rightJoinFields = null;

        if (data?.outputs['output_1']?.connections?.length > 0) {
          joinFields = {
            'left': true,
            'next': next[0]?.toString()
          };
        }
        if (data?.outputs['output_2']?.connections?.length > 0) {
          inJoinFields = {
            'inner': true,
            'next': next[1]?.toString()
          };
        }
        if (data?.outputs['output_3']?.connections?.length > 0) {
          rightJoinFields = {
            'right': true,
            'next': next[2]?.toString()
          };
        }
        obj[element?.id] = {

          'fields': { 'left': leftData, 'right': rightData },
          'left': joinFields,
          'on': {
            'left': element?.leftData || null,
            'right': element?.rightData || null
          },
          'right': rightJoinFields,
          'node': element?.name?.toLowerCase(),
          'inner': inJoinFields,
          'previous': previous
        };
      }
       else if (element?.name === 'Destination') {

        obj[element?.id] = {
          'name': 'dest_'+this._flowBuilder?.timeStamp,
          'node': 'target',
          'type': 'new',
          'previous': previous
        };
      }
      json = JSON.stringify(obj);

    });

    if (this._flowBuilder?.timeStamp == null) {
      const timestamp = new Date().getTime();
      this._flowBuilder.timeStamp = timestamp;
    }


    this.formData.append('json_data', json);
    this.formData.append('workflow_identifier', this._flowBuilder?.timeStamp.toString());
    this.formData.append('sample_size', this._flowBuilder.sampleSize);
    this.RunApi(this.formData,type);
  }


    // --- run API integration ---
    RunApi(formData: FormData,type?:string) {
      // return
      this.subs.add(
        this._flowBuilder.FlowBuilderRunApi(formData)
        .pipe(
          catchError((e:any)=>{
            return of(false)
          })
        )
        .subscribe((res: any) => {
          
          if (res?.status === ApiStatus.ok) {
            this.apiLoadingRun = false;
            if(!type){
              this._toast.success(res?.message);
            }
            this._flowBuilder.showPreview = true;
            this._flowBuilder.showPreviewSection = true;
            if(type){
              this.getPreviewNode();
            }
          } else {
            this.apiLoadingRun = false;
            if(!type){
             this._toast.warning('Run Failed');
            }
          }
        }));
    }


    getPreviewNode() {
      
      const activeNode = this._flowBuilder?.activeNode;
      const nodeId = activeNode?.id;
      let nodeName = '';
      if (activeNode?.name === 'Join') {
        nodeName = 'join_l';
      }
       else 
       if (activeNode?.name === 'Destination') {
        nodeName = 'target';
      }else {
        nodeName = activeNode?.name?.toLocaleLowerCase();
      }
      const timestamp = this._flowBuilder?.timeStamp;
      if (this._flowBuilder?.showPreview === true) {
         this._flowBuilder.tableLoading =true;
        this.subs.add(
          this._flowBuilder.FlowBuilderPreviewApi(nodeId, nodeName, timestamp)
          .pipe(
            finalize(()=>{
              this._flowBuilder.tableLoading =false;
            })
          )
          .subscribe((res: any | []) => {
            this._flowBuilder.isRun =true;
            // if (res?.status === ApiStatus.ok) {
              this._flowBuilder.previewData = res?.result;
              this.testPreview = res?.result;
              this.apiLoadingRun = false;
              // const key = Object.keys(this.testPreview[0]);
              // if (this.testPreview?.column === undefined){
              //   this.testPreview.column= {};
              // }
              // key?.forEach((v: string) => {
              //   this.testPreview.column[v] = {
              //     title: v,
              //     type: 'text'
              //   };
              // });
            // }
  
          }));
      }
    }


    @HostListener('click', ['$event.target.className'])
    onClick(className: string) {
  
      const activeNode = this._flowBuilder?.activeNode;
      const nodeId = activeNode?.id;
      const timestamp = this._flowBuilder?.timeStamp;
      
      
      if (typeof className === 'string' &&  className?.includes('output_') && this._flowBuilder?.showPreview===true) {
        const activeNodeName = this._flowBuilder?.activeNode?.name;
        
        switch (activeNodeName) {
        case nodeType?.join:
          if (className?.includes('1')) {
            // this._flowBuilder.tableLoading =true;
            const nodeName = 'join_l';
            this.subs.add(
              this._flowBuilder.FlowBuilderPreviewApi(nodeId, nodeName, timestamp)
              .pipe(
                finalize(()=>{
                  // this._flowBuilder.tableLoading =false;
                })
              )
              .subscribe((res: any | []) => {
                // if (res?.status === ApiStatus.ok) {
                  this._flowBuilder.previewData = res?.result;
                  this.testPreview = res?.result;
                  activeNode['tempJoinResult']=[];
                  this.apiLoadingRun = false;
                  const key = Object.keys(this.testPreview[0]);
                  const value = Object.values(this.testPreview[0]);
                  value.forEach((v: any, i:number)=>{
                    activeNode['tempJoinResult'].push({
                      'key': key[i], 'value': key[i], 'checked': true
                    });
                  });
                  key?.forEach((v: string, i:number) => {
  
                    this.testPreview.column[v] = {
                      title: v,
                      type: 'text'
                    };
                  });
  
                // }
  
              }));
          }
          if (className?.includes('2')) {
            // this._flowBuilder.tableLoading =true;
            const nodeName = 'join_i';
            this.subs.add(
              this._flowBuilder.FlowBuilderPreviewApi(nodeId, nodeName, timestamp)
              .pipe(
                finalize(()=>{
                  // this._flowBuilder.tableLoading =false;
                })
              )
              .subscribe((res: any | []) => {
  
                // if (res?.status === ApiStatus.ok) {
                  this._flowBuilder.previewData = res?.result;
                  this.testPreview = res?.result;
                  activeNode['tempJoinResult']=res?.result;
                  this.apiLoadingRun = false;
                  const key = Object.keys(this.testPreview[0]);
                  const value = Object.values(this.testPreview[0]);
                  value.forEach((v: any, i:number)=>{
                    activeNode['tempJoinResult'].push({'key': key[i], 'value': key[i], 'checked': true});
                  });
                  key?.forEach((v: string) => {
                    this.testPreview.column[v] = {
                      title: v,
                      type: 'text'
                    };
                  });
                // }
  
              }));
          }
          if (className?.includes('3')) {
            const nodeName = 'join_r';
            // this._flowBuilder.tableLoading =true;
            this.subs.add(
              this._flowBuilder.FlowBuilderPreviewApi(nodeId, nodeName, timestamp)
              .pipe(
                finalize(()=>{
                  // this._flowBuilder.tableLoading =false;
                })
              )
              .subscribe((res: any | []) => {
                // if (res?.status === ApiStatus.ok) {
                  this._flowBuilder.previewData = res?.result;
                  this.testPreview = res?.result;
                  activeNode['tempJoinResult']=res?.result;
                  this.apiLoadingRun = false;
                  const key = Object.keys(this.testPreview[0]);
                  const value = Object.values(this.testPreview[0]);
                  value.forEach((v: any, i:number)=>{
                    activeNode['tempJoinResult']?.push({'key': key[i], 'value': key[i], 'checked': true});
                  });
                  key?.forEach((v: string) => {
                    this.testPreview.column[v] = {
                      title: v,
                      type: 'text'
                    };
                  });
                // }
  
              }));
          }
          break;
  
        case nodeType?.filter:
          if (className?.includes('1')) {
            const nodeName = 'filter_f';
            // this._flowBuilder.tableLoading =true;
            this.subs.add(
              this._flowBuilder.FlowBuilderPreviewApi(nodeId, nodeName, timestamp)
              .pipe(
                finalize(()=>{
                  // this._flowBuilder.tableLoading =false;
                })
              )
              .subscribe((res: any | []) => {
  
                // if (res?.status === ApiStatus.ok) {
                  this._flowBuilder.previewData = res?.result;
                  this.testPreview = res?.result;
                  this.apiLoadingRun = false;
                  const key = Object.keys(this.testPreview[0]);
                  key?.forEach((v: string) => {
                    this.testPreview.column[v] = {
                      title: v,
                      type: 'text'
                    };
                  });
                // }
  
              }));
          }
  
  
          if (className?.includes('2')) {
            const nodeName = 'filter';
            // this._flowBuilder.tableLoading =true;
            this.subs.add(
              this._flowBuilder.FlowBuilderPreviewApi(nodeId, nodeName, timestamp)
              .pipe(
                finalize(()=>{
                  // this._flowBuilder.tableLoading =false;
                })
              )
              .subscribe((res: any | []) => {
                // if (res?.status === ApiStatus.ok) {
                  this.testPreview = res?.result;
                  this._flowBuilder.previewData = res?.result;
                  this.apiLoadingRun = false;
                  const key = Object.keys(this.testPreview[0]);
                  key?.forEach((v: string) => {
                    this.testPreview.column[v] = {
                      title: v,
                      type: 'text'
                    };
                  });
                // }
  
              }));
          }

          break;
  
        default:
          break;
        }
      }
  
    }

}
